import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environment";
import { Observable, retry } from "rxjs";
import { ApplyAutoForecastTemplate, AutoForecast, AutoForecastReviewRequest, AutoForecastReviewResponse, ForecastTemplateList, HideOrUnhideForecastTemplate } from "../interfaces/auto-forecast.interface";
import { DisplayValue } from "../components/labour-hours/labour-hours.component";
import { sanitizeParams } from "../sanitize-params";

@Injectable({ providedIn: "root" })
export class AutoForecastClient {
  endpoint = "auto-forecast";

  constructor(private httpClient: HttpClient) {}

  getAutoForecastTemplateById(id: string) {
    return this.httpClient.get<AutoForecast>(`${environment.endpoint}/${this.endpoint}/get/${id}`);
  }

  getAutoForecastTemplateList(corpid: string, facilityid: string | null | undefined): Observable<ForecastTemplateList[]> {
    let params = new HttpParams().set("corpid", corpid);
    if (facilityid !== null && facilityid !== undefined) {
      params = params.set("facilityid", facilityid);
    }
    return this.httpClient.get<Array<ForecastTemplateList>>(`${environment.endpoint}/${this.endpoint}/get-list`, { params });
  }

  getAutoForecastDropdownlist(facilityid: string): Observable<DisplayValue<string>[]> {
    const params = new HttpParams().set("facilityid", facilityid);
    return this.httpClient.get<DisplayValue<string>[]>(`${environment.endpoint}/${this.endpoint}/get-dropdown-list`, { params });
  }

  reviewBeforeApplyTemplate(autoForecastReviewrequest: AutoForecastReviewRequest): Observable<AutoForecastReviewResponse> {
    return this.httpClient.post<AutoForecastReviewResponse>(`${environment.endpoint}/${this.endpoint}/review-before-apply`, autoForecastReviewrequest);
  }

  applyAutoforecastTemplate(autoforecastTemplate: ApplyAutoForecastTemplate) {
    return this.httpClient.post(`${environment.endpoint}/${this.endpoint}/apply`, autoforecastTemplate);
  }

  addPatientAutoForecastTemplate(autoForecastadd: AutoForecast) {
    return this.httpClient.post(`${environment.endpoint}/${this.endpoint}/add`, autoForecastadd);
  }

  editPatientAutoForecastTemplate(editautoForecast: AutoForecast) {
    return this.httpClient.put(`${environment.endpoint}/${this.endpoint}/edit`, editautoForecast);
  }

  deleteAutoForecastTemplate(id: string) {
    return this.httpClient.delete(`${environment.endpoint}/${this.endpoint}/delete/${id}`);
  }

  hideorunhidetemplate(hideorunhidetemplaterequest: HideOrUnhideForecastTemplate): Observable<boolean> {
    return this.httpClient.patch<boolean>(`${environment.endpoint}/${this.endpoint}/hide-or-unhide-template`, hideorunhidetemplaterequest);
  }
}
